/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import jodit from '../../utils/jodit';

const RichTextEditor = ({ initContent, onContentChange }) => {
	const editor = useRef(null);
	const [content, setContent] = useState('');

	useEffect(() => {
		if (!content && initContent) {
			setContent(initContent);
		}
	}, [initContent]);

	const config = useMemo(
		() => ({
			readonly: false,
			controls: jodit?.controls,
		}),
		[]
	);

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => setContent(newContent)}
			onChange={(newContent) => onContentChange(newContent)}
		/>
	);
};

export default RichTextEditor;
